import { render, staticRenderFns } from "./ProductSecondCard.vue?vue&type=template&id=61ce656e&scoped=true&"
import script from "./ProductSecondCard.vue?vue&type=script&lang=js&"
export * from "./ProductSecondCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductSecondCard.vue?vue&type=style&index=0&id=61ce656e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ce656e",
  null
  
)

export default component.exports